import * as React from 'react'
import { getPriceOrNull } from '../../helpers'
import { useBookingFormStore } from '../../providers/BookingFormStoreProvider'
import { IHotel } from '../../store/data'
import {
  buildImageSrcSet,
  getImageFallbackUrls,
  resolveImageAlt,
  selectImageSource,
} from '../../utils/responsiveImage'
import Card from '../Card/Card'
import Stars from '../Stars'

export type HotelItemProps = {
  data: IHotel
  onLoadHotel?: () => void
  onSelect?: React.MouseEventHandler<HTMLButtonElement>
  selected?: boolean
}

const HotelItem: React.FunctionComponent<HotelItemProps> = ({
  data,
  onLoadHotel = () => {},
  onSelect = () => {},
  selected = false,
}) => {
  const language = useBookingFormStore((state) => state.language)
  const price = getPriceOrNull(data.lowest_price, 'amount_per_night', language)
  const imageUrl = selectImageSource(data.variants, data.thumbnail, data.image)
  const imageSrcSet = buildImageSrcSet(data.variants)

  return (
    <Card
      imageAlt={resolveImageAlt(data.alt, language, data.name)}
      imageFallbackUrls={getImageFallbackUrls(data.thumbnail, data.image)}
      imageHeight={data.height}
      imageSizes="(min-width: 768px) 128px, 100vw"
      imageSrcSet={imageSrcSet}
      imageUrl={imageUrl}
      imageWidth={data.width}
      onDetail={onLoadHotel}
      onSelect={onSelect}
      pretitle={
        <Stars className={selected ? 'text-light' : 'text-theme-main'} value={data.stars || 0} />
      }
      price={price ?? undefined}
      selected={selected}
      title={data.name}
    />
  )
}
export default HotelItem
